import React from "react";

const config = require("../../../config.json")
const client = config.APP_CLIENT;
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY;

const MailLink = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  fontSize: "12px",
  margin: "0px 0px 0px",
  paddingRight: "5px",
  marginRight: "5px",
  lineHeight: "12px",
};
const LinkText = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  fontSize: "12px",
  lineHeight: "12px",
};
const iconLogo = {
  marginRight: "3px",
  transform: "translateY(3px)",
};

export default function Email(email) {
  return (
    <table style={{borderSpacing: 0}}>
      <tbody>
        <tr>
          <td style={{verticalAlign: 'middle'}}>
            <img
              src={`https://files.myclientisrich.com/${client}/mail.png`}
              style={iconLogo}
              alt="logo email"
              width="13"
              height="13"
            ></img>
          </td>
          <td>
            <a href={`mailto:${email.email}`} style={MailLink}><span style={LinkText}>{email.email}</span></a>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
